var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"system"}}),_c('header',{staticClass:"plan-header",class:{'make-big': !_vm.$route.name}},[_c('img',{attrs:{"src":"/img/logo.svg","alt":"Novos"}})]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }